/**
 * /dashboard/accounting/money/receipts/new — Create receipt (G_ACC6c).
 *
 * ?invoice_id= pre-fills the form from an invoice — the invoice detail's
 * "Record payment" action links here (wave-2 lite books): the customer,
 * the allocation to that invoice and what is still due.
 *
 * Migration note (Phase 3e — 2026-06-01): port of
 * frontend/src/app/(dashboard)/dashboard/accounting/money/receipts/new/page.tsx.
 */

import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { AccountingModuleShell } from "@/components/shared/accounting-module-shell";
import { ReceiptForm } from "@/components/accounting/receipt-form";

const newReceiptSearchSchema = z.object({
  invoice_id: z.coerce.number().int().positive().optional().catch(undefined),
});

export const Route = createFileRoute(
  "/_authgated/app/$tenantSlug/accounting/money/receipts/new",
)({
  validateSearch: newReceiptSearchSchema,
  component: NewReceiptRoute,
});

function NewReceiptRoute() {
  const { invoice_id: prefillInvoiceId } = Route.useSearch();
  // Top-of-page Back button removed per Audit 4 Quick-Win #4 — the
  // bottom Cancel handles it.
  return (
    <AccountingModuleShell
      title="New Receipt"
      description="Record a customer payment and apply it to open invoices."
    >
      {/* Re-key on the invoice so a second "Record payment" re-seeds. */}
      <ReceiptForm key={prefillInvoiceId ?? "blank"} prefillInvoiceId={prefillInvoiceId} />
    </AccountingModuleShell>
  );
}
